const initialState = {
    countrydata:[],
    regdata:[],
}
const RegisterReducers= (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_DATA_SUCCESS':
          return { ...state, countrydata: action.payload };
          case 'FETCH_REG_DATA_SUCCESS':
          return { ...state, regdata: action.payload };
          
        default:
          return state;
      }
    };
    export default RegisterReducers;
